import useSWR from 'swr';

import { findLocaleFromUrlAndCookie } from '@zooplus/commons-lang';

import type { MembershipOfferBenefitType } from '@repo/types/membership-offer';
import type { MembershipsComparison, MembershipInfo } from '@repo/types/memberships-comparison';

export function useMembershipsComparison() {
  return useSWR(
    '/semiprotected/api/loyalty-management/memberships/comparison',
    async (...args): Promise<MembershipsComparison> => {
      const response = await fetch(...args, {
        headers: { locale: findLocaleFromUrlAndCookie() || 'en-GB' },
      });

      return await response.json();
    },
    {
      errorRetryInterval: 1000,
      errorRetryCount: 3,
      dedupingInterval: 5000,
      revalidateOnFocus: false,
    },
  );
}

export function useMembershipBenefit(membershipInfo: MembershipInfo) {
  function getMembershipBenefitType<T extends MembershipOfferBenefitType['type']>(
    benefitType: T,
  ): Extract<MembershipOfferBenefitType, { type: T }> | undefined {
    return membershipInfo.benefits.find(
      (benefit): benefit is Extract<MembershipOfferBenefitType, { type: T }> =>
        benefit.type === benefitType,
    );
  }

  return { getMembershipBenefitType };
}
